import { Grid } from '@mui/material';
import { SlideParagraph, SlideTitle } from 'features/slides';

import React from 'react';

export type ImportantInformationProps = {
  readonly porfoliosReviewed: string[] | undefined;
  readonly strategistPerformance: string[] | undefined;
};

export function ImportantInformation({
  porfoliosReviewed,
  strategistPerformance,
}: ImportantInformationProps): React.ReactElement {
  return (
    <Grid item spacing={2} p={2}>
      <Grid item xs={12}>
        <SlideTitle>Important Information</SlideTitle>
      </Grid>

      <Grid item xs={12}>
        <Grid container spacing={2} style={{ padding: '10px 0' }}>
          <Grid item xs={12}>
            <SlideParagraph style={{ fontSize: '11px' }}>
              Portfolios reviewed relative to:
            </SlideParagraph>
          </Grid>
          {porfoliosReviewed?.map(portfolio => (
            <Grid item xs={12} key={portfolio}>
              <SlideParagraph style={{ fontSize: '11px' }}>
                {portfolio}
              </SlideParagraph>
            </Grid>
          ))}
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ padding: '10px 0' }}>
        <Grid item xs={12}>
          <SlideParagraph style={{ fontSize: '12px', fontWeight: '500' }}>
            NOTE:
          </SlideParagraph>
        </Grid>
        <Grid item xs={12}>
          <ul
            style={{
              margin: 0,
              paddingLeft: '24px',
            }}
          >
            <li>
              <SlideParagraph style={{ fontSize: '11px' }}>
                All returns are gross of fees. Please see AssetMark factsheets
                that contain standardized performance periods and net of fees
                returns information
              </SlideParagraph>
            </li>
            <li>
              <SlideParagraph style={{ fontSize: '11px' }}>
                All portfolios use annual rebalancing
              </SlideParagraph>
            </li>
            <li>
              <SlideParagraph style={{ fontSize: '11px' }}>
                Global index blend uses monthly rebalancing
              </SlideParagraph>
            </li>
          </ul>
        </Grid>
      </Grid>

      <Grid container spacing={2} style={{ padding: '10px 0' }}>
        <Grid item xs={12}>
          <SlideParagraph style={{ fontSize: '11px' }}>
            Strategist performance returns are used since the inception of the
            strategy which may include model and composite performance returns.
            Index/blend of indices is used prior to inception of the strategy.
          </SlideParagraph>

          <ul
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '4px',
              margin: 0,
            }}
          >
            {strategistPerformance?.map(performance => (
              <li key={performance}>
                <SlideParagraph style={{ fontSize: '11px' }}>
                  {performance}
                </SlideParagraph>
              </li>
            ))}
          </ul>
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ padding: '10px 0' }}>
        <Grid item xs={12}>
          <SlideParagraph style={{ fontSize: '11px' }}>
            Index and model returns use software programs to track investment
            portfolios, which are considered hypothetical performance and do not
            reflect actual performance. There are inherent limitations in the
            use of hypothetical performance and proxy index information.
          </SlideParagraph>
        </Grid>
      </Grid>

      <Grid container spacing={2} style={{ padding: '10px 0' }}>
        <Grid item xs={12}>
          <SlideParagraph style={{ fontSize: '11px' }}>
            Bloomberg® and the referenced Bloomberg Index are service marks of
            Bloomberg Finance L.P. and its affiliates, (collectively,
            “Bloomberg” ) and are used under license. Bloomberg does not approve
            or endorse this material, nor guarantees the accuracy or
            completeness of any information herein. Bloomberg and AssetMark,
            Inc. are separate and unaffiliated companies.
          </SlideParagraph>
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ padding: '10px 0' }}>
        <Grid item xs={12}>
          <SlideParagraph style={{ fontSize: '11px' }}>
            Please read the Terms of Use posted at{' '}
            <a href="https://www.ewealthmanager.com">www.ewealthmanager.com</a>{' '}
            that govern the use of these materials and also be advised:
          </SlideParagraph>
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ padding: '10px 0' }}>
        <Grid item xs={12}>
          <SlideParagraph style={{ fontSize: '11px' }}>
            AssetMark uses financial market information (“Information”) from
            third-party providers (“Providers”) in reports (“Materials”). The
            Information includes, but is not limited to, financial market data,
            quotes, news, analyst opinions and research reports. The Materials
            are for informational purposes only, not a solicitation or for use
            in the creation/management/offering/sale of any financial instrument
            or product based thereon and should not be considered investment,
            legal or tax advice. The Information has been drawn from sources
            believed to be reliable, but its accuracy and timeliness is not
            guaranteed and is subject to change. You agree that neither
            AssetMark nor the Providers are liable for the use of the
            Information.
          </SlideParagraph>
        </Grid>

        <Grid container spacing={2} style={{ padding: '12px' }}>
          <Grid item xs={12}>
            <SlideParagraph style={{ fontSize: '11px' }}>
              You agree not to redistribute the Information to recipients not
              authorized by AssetMark. You agree that the Providers are
              considered to be third-party beneficiaries of the Terms of Use.
            </SlideParagraph>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
